import React, { useEffect, useRef, useState } from 'react'
import $ from "jquery";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import jszip from "jszip";
import { Link } from 'react-router-dom';
pdfMake.vfs = pdfFonts.vfs;

const Notifications = () => {

    const table1 = useRef(null);

    useEffect(() => {
        window.JSZip = jszip;

        let table11;

        if (table1.current) {
            table11 = $(table1.current).DataTable({
                responsive: true,
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }

        return () => {
            if (table11) table11.destroy();
        };
    }, []);


    return (
        <>
            <div className="page-wrapper">
                <div className="page-content">
                    <div className="page-breadcrumb d-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3 d-none d-xl-block d-lg-block d-md-block">Admin Notifications</div>
                        <div className="ps-3 d-none d-xl-block d-lg-block d-md-block">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Admin Notifications</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="ms-auto">
                        </div>
                    </div>
                    <hr />

                    <div className="entries-wrapper mb-3">
                        <label className="entries-label">
                            <span>Showing</span>
                            <select className="entries-select">
                                <option value={10} selected>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                            <span>Entries</span>
                        </label>
                    </div>
                    <div className="card">
                        <div className="card-body">
                            <div className="tab-content" id="settingsTabContent">
                                <div className="tab-pane fade show active" id="profile" role="tabpanel">
                                    <div className="table-responsive">
                                        <table className="table table-striped table-bordered align-middle" ref={table1}>
                                            <thead className="table-light">
                                                <tr>
                                                    <th>Subject</th>
                                                    <th>Message</th>
                                                    <th>Date &amp; Time</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>New User Signup</td>
                                                    <td>A new user has successfully signed up on the platform and may
                                                        require verification.</td>
                                                    <td>Feb 11, 2026 | 09:15 AM</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2 list-unstyled mb-0">
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#viewNotificationModal">
                                                                    <i className="lni lni-eye" data-bs-toggle="tooltip" title="View" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#deleteNotificationModal">
                                                                    <i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#editNotificationModal">
                                                                    <i className="bx bx-edit" data-bs-toggle="tooltip" title="Edit" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#sendNotificationModal">
                                                                    <i className="bx bx-send" data-bs-toggle="tooltip" title="Send Now" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Package Subscription</td>
                                                    <td>User has subscribed to a package and now has access to its features
                                                        and benefits.</td>
                                                    <td>Feb 10, 2026 | 02:30 PM</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2 list-unstyled mb-0">
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#viewNotificationModal">
                                                                    <i className="lni lni-eye" data-bs-toggle="tooltip" title="View" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#deleteNotificationModal">
                                                                    <i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#editNotificationModal">
                                                                    <i className="bx bx-edit" data-bs-toggle="tooltip" title="Edit" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#sendNotificationModal">
                                                                    <i className="bx bx-send" data-bs-toggle="tooltip" title="Send Now" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Support Request</td>
                                                    <td>User has submitted a support request and is awaiting assistance.
                                                    </td>
                                                    <td>Feb 08, 2026 | 04:20 PM	</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2 list-unstyled mb-0">
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#viewNotificationModal">
                                                                    <i className="lni lni-eye" data-bs-toggle="tooltip" title="View" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#deleteNotificationModal">
                                                                    <i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#editNotificationModal">
                                                                    <i className="bx bx-edit" data-bs-toggle="tooltip" title="Edit" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#sendNotificationModal">
                                                                    <i className="bx bx-send" data-bs-toggle="tooltip" title="Send Now" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Policy Violation</td>
                                                    <td>User has been reported for potential policy violation and requires
                                                        review.</td>
                                                    <td>Feb 09, 2026 | 11:45 AM</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2 list-unstyled mb-0">
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#viewNotificationModal">
                                                                    <i className="lni lni-eye" data-bs-toggle="tooltip" title="View" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#deleteNotificationModal">
                                                                    <i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#editNotificationModal">
                                                                    <i className="bx bx-edit" data-bs-toggle="tooltip" title="Edit" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#sendNotificationModal">
                                                                    <i className="bx bx-send" data-bs-toggle="tooltip" title="Send Now" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-end align-items-center mb-3">
                        <button className="btn btn-primary Create-btn noti-Create-btn" data-bs-toggle="modal" data-bs-target="#createNotificationModal">
                          + Create
                        </button>
                    </div>
                </div>
            </div>

            <div>
                <div className="modal fade" id="viewNotificationModal" tabIndex={-1} aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h5 className="modal-title">Notification Details</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" />
                            </div>
                            {/* Modal Body */}
                            <div className="modal-body">
                                {/* Subject */}
                                <div className="row mb-3">
                                    <div className="col-sm-3">
                                        <h6 className="mb-0">Subject</h6>
                                    </div>
                                    <div className="col-sm-9">
                                        <input type="text" className="form-control" readOnly defaultValue="New User Signup" />
                                    </div>
                                </div>
                                {/* Recipient */}
                                {/* Date & Time */}
                                <div className="row mb-3">
                                    <div className="col-sm-3">
                                        <h6 className="mb-0">Date &amp; Time</h6>
                                    </div>
                                    <div className="col-sm-9">
                                        <input type="text" className="form-control" readOnly defaultValue="Feb 11, 2026 | 09:15 AM" />
                                    </div>
                                </div>
                                {/* Message */}
                                <div className="row mb-3">
                                    <div className="col-sm-3">
                                        <h6 className="mb-0">Message</h6>
                                    </div>
                                    <div className="col-sm-9">
                                        <textarea className="form-control" rows={5} readOnly defaultValue={"A new user has successfully signed up on the platform and may require verification."} />
                                    </div>
                                </div>
                            </div>
                            {/* Modal Footer */}
                            <div className="modal-footer">
                                <button className="btn btn-decline" data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="editNotificationModal" tabIndex={-1} aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header ">
                                <h5 className="modal-title">Edit Notification</h5>
                                <button type="button" className="btn-close " data-bs-dismiss="modal" />
                            </div>
                            <div className="modal-body">
                                <form>
                                    {/* Subject */}
                                    <div className="mb-3">
                                        <div className="row">
                                            <div className="col-sm-4">
                                                <label className="form-label">Subject</label>
                                            </div>
                                            <div className="col-sm-8">
                                                <input type="text" className="form-control" defaultValue="New User Signup" />
                                            </div>
                                        </div>
                                    </div>
                                    {/* Message */}
                                    <div className="mb-3">
                                        <div className="row">
                                            <div className="col-sm-4">
                                                <label className="form-label">Message</label>
                                            </div>
                                            <div className="col-sm-8">
                                                <textarea className="form-control" style={{ height: 150 }} defaultValue={"A new user has successfully signed up on the platform and may require verification."} />
                                            </div>
                                        </div>
                                    </div>
                                    {/* Date & Time */}
                                    <div className="mb-3">
                                        <div className="row">
                                            <div className="col-sm-4">
                                                <label className="form-label">Date &amp; Time</label>
                                            </div>
                                            <div className="col-sm-8">
                                                <input type="datetime-local" className="form-control" />
                                            </div>
                                        </div>
                                    </div>
                                    {/* Recipients */}
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-decline" data-bs-dismiss="modal">Save </button>
                                <button type="button" className="btn btn-approve" data-bs-dismiss="modal">Send Now</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="deleteNotificationModal" tabIndex={-1} aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirmation Alert!</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" />
                            </div>
                            <div className="modal-body">
                                <h5>Do you want to delete this notification?</h5>
                            </div>
                            <div className="modal-footer justify-content-center">
                                <button type="button" className="btn btn-decline" data-bs-dismiss="modal">No</button>
                                <button type="button" className="btn btn-approve" data-bs-dismiss="modal">Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="createNotificationModal" tabIndex={-1} aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Create Notification</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" />
                            </div>
                            <div className="modal-body">
                                <form>
                                    <div className="mb-3">
                                        <label className="form-label">Subject</label>
                                        <input type="text" className="form-control" placeholder="Enter notification subject" />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Date &amp; Time</label>
                                        <input type="datetime-local" className="form-control" />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Message</label>
                                        <textarea className="form-control" rows={5} placeholder="Type your message here" defaultValue={""} />
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-decline" data-bs-dismiss="modal">Save Draft</button>
                                <button className="btn btn-approve" data-bs-dismiss="modal">Send Now</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="sendNotificationModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Confirmation Alert!</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                            </div>
                            <div className="modal-body">
                                <div className="create_noti_form">
                                    <h5>
                                        Do you want to send this message?
                                    </h5>
                                </div>
                            </div>
                            <div className="modal-footer justify-content-center">
                                <button type="button" className="btn btn-decline" data-bs-dismiss="modal">No</button>
                                <button type="button" className="btn btn-approve" data-bs-dismiss="modal">Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Notifications